import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 500,
      textTransform: 'capitalize',
    },

    cardContentPadding: {
      padding: '16px 48px',
    },

    vehicleGroupImg: {
      maxWidth: '100%',
    },

    list: {
      alignItems: 'flex-start',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
    },

    listItem: {
      width: '100%',
      padding: '0 4px 0 0',
      borderBottom: `1px solid ${theme.palette.dividers.primary}`,

      '&:last-child': {
        border: 0,
      },
    },
  };
});

const listStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 10,
      marginTop: 10,
      textAlign: 'right',
    },

    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 600,
      lineHeight: 1,
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 400,
      lineHeight: 1,
      wordBreak: 'break-word',
      maxWidth: '70%',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

export { useStyles, listStyles, customCardStyles };
